import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=0d48169d&scoped=true&"
import script from "@/components/navigation/Navigation.ts?vue&type=script&lang=ts&"
export * from "@/components/navigation/Navigation.ts?vue&type=script&lang=ts&"
import style0 from "./navigation.scss?vue&type=style&index=0&id=0d48169d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d48169d",
  null
  
)

export default component.exports